module.exports = __webpack_public_path__ + "static/media/doc-pic-1.d01ed6a7.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/resources/doc-pic-1.JPG
// module id = 85
// module chunks = 0